/** Whether Issue may be pressed on the preview shown, and why not. */
export function issueGate(
  preview: { difference: number } | null,
  s: { confirmed: boolean; busy: boolean },
): { enabled: boolean; needsConfirmation: boolean; reason: string | null } {
  if (!preview) {
    return {
      enabled: false,
      needsConfirmation: false,
      reason: 'Preparing the preview',
    };
  }
  const needsConfirmation = Math.round(preview.difference * 100) !== 0;
  if (s.busy) return { enabled: false, needsConfirmation, reason: null };
  if (needsConfirmation && !s.confirmed) {
    return {
      enabled: false,
      needsConfirmation,
      reason: 'Confirm the difference between collected and due to issue',
    };
  }
  return { enabled: true, needsConfirmation, reason: null };
}

export type SettleRefusal<P> =
  | { kind: 'stale'; preview: P; message: string }
  | { kind: 'confirm'; message: string }
  | { kind: 'issued'; finalInvoiceId: number; message: string }
  | { kind: 'refused'; message: string };

/** What a refused Issue (or preview) tells the dialog to do next. */
export function settleRefusal<P>(body: string): SettleRefusal<P> {
  let parsed: {
    code?: string;
    error?: string;
    preview?: P;
    finalInvoiceId?: number;
  } | null = null;
  try {
    parsed = JSON.parse(body);
  } catch {
    parsed = null;
  }
  if (!parsed || typeof parsed !== 'object') {
    return { kind: 'refused', message: body || 'Issuing was refused.' };
  }
  const message = parsed.error ?? 'Issuing was refused.';
  if (parsed.code === 'PREVIEW_OUT_OF_DATE' && parsed.preview) {
    return { kind: 'stale', preview: parsed.preview, message };
  }
  if (parsed.code === 'DIFFERENCE_NOT_CONFIRMED')
    return { kind: 'confirm', message };
  if (parsed.code === 'ALREADY_ISSUED' && parsed.finalInvoiceId != null) {
    return { kind: 'issued', finalInvoiceId: parsed.finalInvoiceId, message };
  }
  return { kind: 'refused', message };
}
